import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../../utils/tpoGenQueryKeys';
import { sendNotification } from 'utils/helperMethods';

const deletePlan = async (planId: string) => {
    const token = localStorage.getItem('accessToken');
    const response = await axios(tpoGenUrls.deletePlan(planId), {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

const useDeletePlanMutation = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: (planId: string) => deletePlan(planId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.planningGroups() });
            queryClient.removeQueries({ queryKey: [...tpoGenKeys.all, 'plan-list'] });
            queryClient.removeQueries({ queryKey: [...tpoGenKeys.all, 'importable-plans'] });
            queryClient.invalidateQueries({ queryKey: ['calendarData'] });
            sendNotification('success', 'Plan deleted successfully');
            onSuccess?.();
        },
        onError: (error: any) => {
            const message =
                error?.response?.data?.detail || error?.response?.data?.message || error?.message || 'Failed to delete';
            sendNotification('error', message);
        },
    });

    return { mutate, isPending };
};

export default useDeletePlanMutation;
